import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import injectSheet from 'react-jss';

import * as organizationConstants from '../../constants/organizations';
import * as bucketSelectors from '../../selectors/bucketSelectors';
import * as organizationSelectors from '../../selectors/organizationSelectors';

import Search from '../../components/search/Search';
import Divider from '../../components/Divider';

const Actions = ({ bucketName, onChange, classes, organizationId }) => (
    <React.Fragment>
        <div className={classes.wrapper}>
            <div className={classes.content}>
                <Search
                    value={bucketName}
                    onChange={e => onChange(e, organizationId)}
                    placeholder="Search projects..."
                />
            </div>
        </div>
        <Divider horizontal />
    </React.Fragment>
);

const mapStateToProps = state => ({
    bucketName: bucketSelectors.getOrganizationBucketsFilterName(state),
    organizationId: organizationSelectors.getCurrentOrganizationId(state),
});

const mapDispatchToProps = dispatch => ({
    onChange: (value, organizationId) => {
        dispatch({
            type: organizationConstants.CHANGE_ORGANIZATION_BUCKETS_SEARCH,
            payload: value,
        });
        dispatch({
            type: organizationConstants.FETCH_ORGANIZATION_BUCKETS_REQUEST,
            payload: {
                organizationId: organizationId,
                filterName: value,
                resetList: true,
            },
        });
    },
});

Actions.propTypes = {
    bucketName: PropTypes.string,
};

Actions.defaultProps = {
    bucketName: '',
};

const style = ({ spacing }) => ({
    wrapper: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%',
        height: spacing.maxActionComponentHeight,
    },
    content: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        width: '100%',
        maxWidth: spacing.maxWidth,
    },
});

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(injectSheet(style)(Actions));



// WEBPACK FOOTER //
// ./src/containers/organizationBuckets/Actions.js